import { NAME } from './constants';

export const SHOW_MODAL = `${NAME}/SHOW_MODAL`;
export const HIDE_MODAL = `${NAME}/HIDE_MODAL`;
export const CONFIRM_MODAL = `${NAME}/CONFIRM_MODAL`;
export const CANCEL_MODAL = `${NAME}/CANCEL_MODAL`;



// WEBPACK FOOTER //
// ./modules/Modal/redux/actionTypes.js